import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  return (
    <main className="about-page" id="main-content">
      <section className="about-hero" aria-labelledby="about-title">
        <div className="about-hero__image-wrap">
          <img
            className="about-hero__image"
            src="/img/generated/about-studio.png"
            alt="A designer reviewing paper and cover materials in a studio"
          />
        </div>
        <div className="about-hero__content">
          <p className="about-eyebrow">Our story</p>
          <h1 id="about-title">Plans become a life, one page at a time.</h1>
          <p>
            {siteConfig.description} We make thoughtful tools for the quiet work
            of deciding what matters—and creating space for it.
          </p>
        </div>
      </section>

      <section className="about-story" aria-labelledby="story-title">
        <div className="about-story__content">
          <p className="about-eyebrow">Made for your rhythm</p>
          <h2 id="story-title">A considered approach to everyday planning</h2>
          <p>
            {siteConfig.brandName} began with a simple belief: organization can
            feel personal, tactile, and beautiful. Our collections pair a calm
            visual language with flexible formats, so the system adapts as your
            days change.
          </p>
          <p>
            From the weight of the paper to the spacing of each line, every
            detail is reviewed for clarity and ease. The result is a modular
            collection designed to be used, rearranged, annotated, and made
            entirely your own.
          </p>
          <Link className="about-text-link" to="/shop">
            Explore the collection <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>
        <div className="about-story__image-wrap">
          <img
            className="about-story__image"
            src="/img/generated/about-craft.png"
            alt="A craftsperson carefully aligning planner pages"
            loading="lazy"
          />
        </div>
      </section>

      <section className="about-values" aria-labelledby="values-title">
        <div className="about-values__heading">
          <p className="about-eyebrow">What guides us</p>
          <h2 id="values-title">Purpose in every detail</h2>
        </div>
        <div className="about-values__grid">
          <article>
            <span>01</span>
            <h3>Designed with intention</h3>
            <p>
              Clean layouts, useful formats, and enduring materials create
              systems that support focus without adding noise.
            </p>
          </article>
          <article>
            <span>02</span>
            <h3>Personal by nature</h3>
            <p>
              Mix-and-match pieces invite you to build a planning practice
              around your own priorities, pace, and point of view.
            </p>
          </article>
          <article>
            <span>03</span>
            <h3>Made for the everyday</h3>
            <p>
              Thoughtful construction and practical details are made to meet
              real routines—from first notes to finished plans.
            </p>
          </article>
        </div>
      </section>

      <section className="about-closing" aria-labelledby="about-closing-title">
        <p className="about-eyebrow">Begin where you are</p>
        <h2 id="about-closing-title">Make room for what comes next.</h2>
        <p>
          Build a planning system that feels as considered as the life it
          holds.
        </p>
        <Link className="about-button" to="/shop">
          Shop all essentials
        </Link>
      </section>
    </main>
  );
}

export default About;
